@if (customerAccountData && (customerAccountData.isSecurityAnswerRequired || customerAccountData.isSecurityPinRequired)) {
  <div class="customer-account-container flex flex-column gap-3 mb-5"
    >
    <div>
      <span class="title">
        <app-translate key="ACCOUNT_SECURITY_INFORMATION"></app-translate>
      </span>
    </div>
    @if (customerAccountData && customerAccountData.isSecurityPinRequired) {
      <div>
        <span class="sub-title">
          <app-translate key="PASSCODE_DESCRIPTION"></app-translate>
        </span>
      </div>
    }
    <p-divider></p-divider>
    @if (customerAccountForm && customerAccountData) {
      <div>
        <div class="grid" [formGroup]="customerAccountForm">
          @if (customerAccountData.isSecurityPinRequired) {
            <div class="col-12">
              <div class="flex justify-content-between">
                <span class="sub-title">
                  <app-translate key="PASSCODE_LENGTH_REQUIREMENT"></app-translate>
                </span>
                <i class="pi pi-info-circle align-self-center" severity="secondary" tooltipPosition="top"
                  (onClick)="legendPopover.toggle($event)" (mouseenter)="legendPopover.toggle($event)">
                  <p-popover #legendPopover styleClass="border-1 border-round-lg w-25rem"
                    my="center top" at="right center">
                    <div class="flex flex-column font-bold">
                      <div>
                        <p class="text-sm m-0 p-0 line-height-3">
                          <app-translate key="PASSCODE_INFO_TOOLTIP"></app-translate>
                        </p>
                      </div>
                    </div>
                  </p-popover>
                </i>
              </div>
            </div>
            <div class="col-6">
              <div class="flex flex-column flex-1">
                <label htmlFor="passcode" class="form-label"><app-translate key="PASSCODE"></app-translate></label>
                <p-password formControlName="pass" [toggleMask]="true" styleClass="w-full" inputStyleClass="w-full mb-1"
                  (onFocus)="sendCustomerInputMessage('passcode')" appNumericOnly [minlength]="6" [maxLength]="8"
                inputId="passcode" [feedback]="false"></p-password>
                <sp-control-error [parameters]="['Passcode']"
                  [messagesParameters]="[{key : 'pattern', message : 'Please enter a valid passcode'}]"
                [control]="customerAccountForm.get('pass')"></sp-control-error>
              </div>
            </div>
            <div class="col-6">
              <div class="flex flex-column flex-1">
                <label htmlFor="confirmPasscode" class="form-label"><app-translate
                key="CONFIRM_PASSCODE"></app-translate></label>
                <p-password formControlName="repass" appNumericOnly [toggleMask]="true" styleClass="w-full"
                  inputStyleClass="w-full mb-1" inputId="confirmPasscode"
                  (onFocus)="sendCustomerInputMessage('confirm passcode')" [minlength]="6" [maxLength]="8"
                [feedback]="false"></p-password>
            <sp-control-error [parameters]="['Confirm Passcode']" [messagesParameters]="[
                                {key : 'passwordMismatch', message : 'Passcode does not match confirm passcode'},
                                {key : 'min', message : 'Passcode is not minimum of 6 digits'}]"
                [control]="customerAccountForm.get('repass')"></sp-control-error>
              </div>
            </div>
          }
          @if (customerAccountData.isSecurityAnswerRequired) {
            <div class="col-12 mt-2">
              <span class="sub-title">
                <app-translate key="SECURITY_QUESTION_DESCRIPTION"></app-translate>
              </span>
            </div>
            <div class="col-12 md:col-6">
              <div class="flex flex-column flex-1">
                <label htmlFor="securityQuestion" class="form-label"><app-translate
                key="SECURITY_QUESTION"></app-translate></label>
                <p-select styleClass="w-full" formControlName="securityQuestion" [options]="lstQuestions"
                  optionLabel="Question" optionValue="Question"
                  [placeholder]="languageService.getTranslation('SELECT_QUESTION')" />
                <sp-control-error [parameters]="['Security Question']"
                [control]="customerAccountForm.get('securityQuestion')"></sp-control-error>
              </div>
            </div>
            <div class="col-12 md:col-6">
              <div class="flex flex-column flex-1">
                <label htmlFor="securityAnswer" class="form-label"><app-translate
                key="SECURITY_ANSWER"></app-translate></label>
                <p-password formControlName="securityAnswer" [toggleMask]="true" styleClass="w-full"
                  inputStyleClass="w-full mb-1" inputId="securityAnswer"
                (onFocus)="sendCustomerInputMessage('security answer')" [maxLength]="50" [feedback]="false"></p-password>
                <sp-control-error [parameters]="['Security Answer']"
                [control]="customerAccountForm.get('securityAnswer')"></sp-control-error>
              </div>
            </div>
          }
          <ng-container>
            <div class="col-12 md:col-6">
              @if (customerAccountData.isCouponCodeAvailable) {
                <div class="flex flex-column flex-1">
                  <label htmlFor="coupon" class="form-label"><app-translate key="COUPON_CODE"></app-translate></label>
                  <input pInputText id="coupon" placeholder="Enter code" formControlName="coupon" maxlength="13"
                    pattern="[A-Za-z0-9]*" class="mb-1" (input)="onAlphanumericInput($event)" />
                </div>
              }
            </div>
          </ng-container>
        </div>
        <div class="mt-3">
          <div class="mb-3">
            <p-button [label]="languageService.getTranslation('SUBMIT')" (onClick)="onSubmitClicked()"
              styleClass="p-button-lg w-full p-button-primary" />
          </div>
          <div class="mb-3">
            <p-button [label]="languageService.getTranslation('CANCEL')" [link]="true" styleClass="w-full"
              (onClick)="onCancelClick()" />
          </div>
        </div>
        <div>
          <span class="sub-title">
            <app-translate key="PRIVATE_INFO_SECURITY"></app-translate>
          </span>
        </div>
      </div>
    }
  </div>
}

@if (!customerAccountData || (!customerAccountData.isSecurityAnswerRequired && !customerAccountData.isSecurityPinRequired)) {
  <div
    >
    <app-translate key="SECURITY_FLAGS_FALSE"></app-translate>
  </div>
}

<app-confirm-popup [title]="languageService.getTranslation('CANCEL_CONFIRMATION_TEXT')"
  [header]="languageService.getTranslation('CONFIRM_CANCELLATION')" [(isVisible)]="showCancelDialog"
(Result)="onCancel($event)"></app-confirm-popup>
